import { AdvanceSearchFormType, ICustomerData } from 'pages/customer/type';
import reducer from './reducer';
import * as CustomerActions from './actions';

export type CustomerMasterStateType = AdvanceSearchFormType & {
  customerList: ICustomerData[];
  isListFromAdvancedSearch: boolean
}

export {
  CustomerActions,
};

export default reducer;
